/* import __COLOCATED_TEMPLATE__ from './cta-link.hbs.js'; */
var _dec, _class;
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { tagName } from '@ember-decorators/component';
import Component from '@ember/component';
import { assert } from '@ember/debug';

/**
## EventTimeline/Link

Link that supports both actions and URLs for use in the event-timeline component.

@param {String} linkClass - CSS class to apply to link
@param {String} callToAction.text - text for the call to action
@param {String} callToAction.href - URL if call to action should be a link (cannot be used with `callToAction.action`)
@param {Action} callToAction.action - action if there is a call to action (cannot be used with `callToAction.href`)
*/
let CtaLink = (_dec = tagName(''), _dec(_class = class CtaLink extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "linkClass", null);
    _defineProperty(this, "callToAction", null);
  }
  init(...args) {
    super.init(...args);
    const {
      href,
      action
    } = this.callToAction;
    assert('{{event-timeline/cta-link}} cannot does not support both `href` and `action`', !(href && action));
    assert('{{event-timeline/cta-link}} requires either `href` or `action`', href || action);
  }
}) || _class);
export { CtaLink as default };